import React, { useState } from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import useCareerExploration from './CareerExplorationProvider'
import { cn } from '~/lib/utils'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '~/lib/ui/collapsible'
import { Button } from '~/lib/ui/button'
import useTranslation from '../shared/TranslationProvider'

const TechnologySkillsSection = ({ career, ...props }) => {
  const { technology_skills } = career
  const [isOpen, setIsOpen] = useState(false)

  const technologySkills = Object.keys(technology_skills)

  const skillsToShow = technologySkills.slice(0, 5)
  const expandedSkills = technologySkills.slice(5)

  const { t } = useTranslation('skills')

  if (!technologySkills?.length)
    return <NotAvailable section="skills" career={career} {...props} />

  return (
    <ResultsSection section="skills" career={career} {...props}>
      <div className="flex flex-col gap-2">
        {skillsToShow.map((skill, idx) => (
          <SkillSection
            key={`tech_skill-${idx}`}
            skill={technology_skills[skill]}
          />
        ))}
      </div>
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        {!isOpen && (
          <CollapsibleTrigger className="transition-all duration-200" asChild>
            <Button variant="link">{t('show_more')}</Button>
          </CollapsibleTrigger>
        )}
        <CollapsibleContent
          className={cn(
            'overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
          )}
        >
          <div className="flex flex-col gap-2">
            {expandedSkills.map((skill, idx) => (
              <SkillSection
                key={`tech_skill-${idx}`}
                skill={technology_skills[skill]}
              />
            ))}
          </div>
        </CollapsibleContent>
        {isOpen && (
          <CollapsibleTrigger className="transition-all duration-200" asChild>
            <Button variant="link">{t('show_less')}</Button>
          </CollapsibleTrigger>
        )}
      </Collapsible>
    </ResultsSection>
  )
}

export default TechnologySkillsSection

const SkillSection = ({ skill }) => {
  const { textifySkillInfo } = useCareerExploration()
  return (
    <div>
      <span className="font-bold">{skill[0]}</span> -{' '}
      {textifySkillInfo(skill[1])}
    </div>
  )
}
